export enum OpportunityPackageVisibility {
  TYPE_PUBLIC_DEAL = 'Public Deal',
  TYPE_CONFIDENTIAL = 'Confidential'
}
